import { Alert, Platform } from 'react-native';

/**
 * Cross-platform alert function that works on both web and native.
 * On web, React Native's Alert.alert is a no-op, so we use window.alert instead.
 * 
 * @param title - The title of the alert
 * @param message - The message to display
 */
export const showAlert = (title: string, message: string) => {
  if (Platform.OS === 'web') {
    window.alert(`${title}\n\n${message}`);
  } else {
    Alert.alert(title, message);
  }
};

